import { Injectable } from '@angular/core';
import { Title, Meta } from '@angular/platform-browser';
import { environment } from 'src/environments/environment';
@Injectable()
export class SeoService {
    readonly siteTitle = environment.appName;

    constructor(private title: Title, private meta: Meta) { }

    setTitle(title: string[]): SeoService {
        title.push(this.siteTitle);
        this.title.setTitle(title.join(' | '));
        return this;
    }

    setDescription(description: string): SeoService {
        this.meta.updateTag({
            name: 'description',
            content: description
        });
        return this;
    }
}
